import {AxiosPromise} from "axios";
import {CONSTANT_CONFIG} from "@/constants";
import { HttpService } from "@/services/http.services";

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.CORE_SERVER_PREFIX}/crop-seed-demand`
const endpoints = {
    list: () => `${RESOURCE_ENDPOINT}`,
    getById: (id: any) => `${RESOURCE_ENDPOINT}/${id}`,
    create: () => `${RESOURCE_ENDPOINT}`,
    update: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    updatePartial: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    delete: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    bulk: () => `${RESOURCE_ENDPOINT}/bulk`,
    dropdown: () => `${RESOURCE_ENDPOINT}/dropdown`,
    getPreviousCropSeedDemandData: () => `${RESOURCE_ENDPOINT}/get-previous-crop-seed-demand-data`,
    getCropSeedDeamndDataForProduction: () => `${RESOURCE_ENDPOINT}/get-crop-seed-demand-data-for-production`,
    getCropSeedDeamndBlockData: () => `${RESOURCE_ENDPOINT}/get-crop-seed-demand-block-data`,
    preferenceCropVarietyList: () => `${RESOURCE_ENDPOINT}/upazila-wise-variety-preference`,
    getByIdBlockId: (id: any, blockId:any) => `${RESOURCE_ENDPOINT}/getByIdBlockId/${id}/${blockId}`,
}

export default class CropSeedDemandApi {
    public list = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.list();
        return HttpService.get(url, params, headers);
    }

    public getById = (id: any, params = {}): AxiosPromise<any> => {
        const url = endpoints.getById(id);
        return HttpService.get(url, params);
    }

    public create = (payload: any, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.create();
        return HttpService.post(url, payload, params, headers);
    }

    public update = (id: any, payload: any, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.update(id);
        return HttpService.put(url, payload, params, headers);
    }

    public updatePartial = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.updatePartial(id);
        return HttpService.patch(url, payload, params, headers);
    }

    public delete = (id: any, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.delete(id);
        return HttpService.delete(url, params, headers);
    }

    public bulk = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.bulk();
        return HttpService.post(url, payload, params, headers);
    }

    public dropdown = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.dropdown();
        return HttpService.get(url, params, headers);
    }

    public getPreviousCropSeedDemandData = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getPreviousCropSeedDemandData();
        return HttpService.get(url, params, headers);
    }

    public getCropSeedDeamndDataForProduction = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getCropSeedDeamndDataForProduction();
        return HttpService.get(url, params, headers);
    }

    public getCropSeedDeamndBlockData = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getCropSeedDeamndBlockData();
        return HttpService.post(url, payload, params, headers);
    }

     public preferenceCropVarietyList = (params = {}, headers = {}): AxiosPromise<any> => {
            const url = endpoints.preferenceCropVarietyList();
            return HttpService.get(url, params, headers);
    }

    public getByIdBlockId = (id:any, blockId:any): AxiosPromise<any> => {
        const url = endpoints.getByIdBlockId(id, blockId);
        return HttpService.get(url);
    }
}
